import { get, post } from "../../config/api";
import { TASK_STATUSES_REVERSE_MAP } from "../TaskConstants";

class TaskService {

    static async getRecentTasks(kitchenId, { size = 10, before, after, inclusive, signal } = {}) {
        const params = new URLSearchParams();
        params.set("size", String(size));
        if (before) params.set("before", before);
        if (after) params.set("after", after);
        if (inclusive) params.set("inclusive", "true");
        const url = `/v3/dashboard/kitchen/${kitchenId}/task/list?${params.toString()}`;
        return await get({ url, signal });
    }

    static async getTasksByFilter(params) {

        let paramString = "";

        if(params?.length) {
            for(const param of params) {
                if(paramString.length) paramString += "&";
                paramString += `${param.type}=${param.value}`;
            }
        }

        const url = `/v3/dashboard/kitchen/task/list?${paramString}`;
        return await get({ url }); 
    }

    static async getTaskData(kitchenId, taskId) {
        const url = `/v3/dashboard/kitchen/task/${taskId}`;
        return await get({ url }); 
    }

    static async getActiveTasks(kitchenId) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/task/status?status=${TASK_STATUSES_REVERSE_MAP.IN_PROGRESS}&status=${TASK_STATUSES_REVERSE_MAP.READY_TO_SEND}&status=${TASK_STATUSES_REVERSE_MAP.PICKED_UP}`;
        return await get({ url });
    }

    static async killActiveTask(data) {
        const url = `/v3/dashboard/kitchen/task/failActiveTask`;
        return await post({ url, data });

    }

    static async getTaskAssets(data) {
        const url = `/v3/dashboard/kitchen/task/asset`;
        return await post({ url, data });
    }
}

export default TaskService